import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export var INDIVIDUAL_LIST = [
    "บุคคลธรรมดา",
    "ร้านค้า"
];
var getFullAddress = function(addr, district, amphoe, province, postalCode) {
    return "".concat(addr, " ต.").concat(district, " อ.").concat(amphoe, " จ.").concat(province, " ").concat(postalCode);
};
export function getMemberProp(member) {
    var memberProp = _object_spread_props(_object_spread({}, member), {
        is_hq: false,
        branch_no: null,
        additional_info: null,
        business_type: null,
        customer_type: member.customer_type,
        full_name: null,
        full_address: null,
        address: null,
        district: null,
        amphoe: null,
        province: null,
        postal_code: null,
        tax_id: null
    });
    if (member.customer_type === "บุคคลธรรมดา") {
        memberProp.full_name = [
            member.first_name,
            member.last_name
        ].filter(Boolean).map(function(str) {
            return str.trim();
        }).join(" ");
        memberProp.full_name = (member.prefix_name || "") + memberProp.full_name;
    } else {
        memberProp.is_hq = member.is_cti_hq;
        memberProp.branch_no = member.cti_branch_no;
        memberProp.additional_info = member.additional_info;
        memberProp.business_type = member.cti_type;
        memberProp.full_name = [
            member.prefix_comp_name,
            member.comp_name,
            member.comp_last_name
        ].filter(Boolean).map(function(str) {
            return str.trim();
        }).join(" ");
    }
    if (INDIVIDUAL_LIST.includes(member.customer_type)) {
        memberProp.full_address = getFullAddress(member.pti_address, member.pti_district, member.pti_amphoe, member.pti_province, member.pti_postal_code);
        memberProp.address = member.pti_address;
        memberProp.district = member.pti_district;
        memberProp.amphoe = member.pti_amphoe;
        memberProp.province = member.pti_province;
        memberProp.postal_code = member.pti_postal_code;
        memberProp.tax_id = member.tax_id || member.pti_tax_id;
    } else {
        memberProp.full_address = getFullAddress(member.cti_address, member.cti_district, member.cti_amphoe, member.cti_province, member.cti_postal_code);
        memberProp.address = member.cti_address;
        memberProp.district = member.cti_district;
        memberProp.amphoe = member.cti_amphoe;
        memberProp.province = member.cti_province;
        memberProp.postal_code = member.cti_postal_code;
        memberProp.tax_id = member.cti_tax_id;
    }
    return memberProp;
}
export function mappingSearchMember(member) {
    var memberProp = getMemberProp(member);
    return {
        customerID: memberProp.tax_id,
        customerCode: memberProp.customer_id,
        customerName: memberProp.full_name,
        customerNameShort: "-",
        branchCode: memberProp.branch_no || "",
        branchName: memberProp.additional_info || "",
        address: memberProp.address ? memberProp.full_address : "",
        phoneNumber: memberProp.phone_number
    };
}
export function isShowBranch(param) {
    var custType = param.custType, isHQ = param.isHQ, branchNo = param.branchNo;
    return !INDIVIDUAL_LIST.includes(custType) && (isHQ || branchNo);
}
